import { remoteFAZAction } from './actions';
import { initialState, make_reducer } from '../../devGroups/reducer_util';

export const remoteFAZReducer = (state = initialState, action) =>
  make_reducer(remoteFAZAction)(state, action);
